import React from 'react';
import {useStyles} from "./BoxCard.style";
import BoxCardProperties from "./BoxCardProperties";
import clsx from "clsx";
import BoxCardType from "./BoxCardType";
import PageLoading from "../PageLoading/PageLoading";
import {useI18nContext} from "../../contexts/I18nContext";


const BoxCard: React.FC<BoxCardProperties> = ({
                                                  className = '',
                                                  loading = false,
                                                  title,
                                                  type = BoxCardType.DEFAULT,
                                                  children
                                              }) => {
    const classes = useStyles();
    const i18n = useI18nContext();

    const getClass = () => {
        switch (type) {
            case BoxCardType.PRIMARY:
                return classes.primary;
            case BoxCardType.SECONDARY:
                return classes.secondary;
            default:
                return classes.default;
        }
    }
    return (
        <div className={classes.box_container}>
            {title && <div className={clsx(classes.box_header, getClass())}>{title}</div>}
            <div className={classes.box_body}>
                {children}
                <PageLoading isLoading={loading} text={`${i18n.translate("LOADING")} ${title}`}/>
            </div>
        </div>
    )
}
export default BoxCard;